var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 161.405,
    height: 53.6,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3696.6 1227.58",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 1848.3,
    y1: 1781.68,
    x2: 1848.3,
    y2: 142.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 1837.55,
    y1: -147.15,
    x2: 1861.32,
    y2: 1373.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3220.78,
    y1: 2092.33,
    x2: 3034.9,
    y2: 1164.39
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3583.67,
    y1: 1918.08,
    x2: 3422.54,
    y2: 1030.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 2855.71,
    y1: -3233.88,
    x2: 2712.33,
    y2: 270.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#c6722c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    style: {
      stopOpacity: 1,
      stopColor: "#c6722c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#a85823"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 1898.22,
    y1: 2487.57,
    x2: 1622.41,
    y2: 1517.75
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 2688.2,
    y1: 2318.17,
    x2: 2501.44,
    y2: 1398.14
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3579.89 156.01c-18.41 46.75-48.37 85.84-85.17 111.01-158.1-86.58-396.66-40.86-567.24-14.7-100.53 15.36-201.28 30.36-302.04 44.68h-777.73c353.94-62.12 708.36-124.22 1064.19-178.01 196.57-29.97 479.21-51.63 667.99 37.01z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3696.6 412.03v403.52c0 226.67-173.48 412.03-385.22 412.03H413.68C186.37 1227.58 0 1037.94 0 806.02V393.04c0-75.08 20.89-145.44 57.37-205.33 36.46-60.37 188.14-106.75 256.66-93.9 36.46 6.67 52.01 57.9 44.89 38.44-4.46-12.85-6.6-61.42 3.18-78.83C387.78 7.7 484.43 0 503.97 0l2835.2 5.83c235.56 44.99 357.43 179.5 357.43 406.2z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3568.9 359.39V711.3c0 18.22-1.22 36.49-4.15 54.32-5.8 38.55-17.8 75.01-35.18 108.17-12.82 25.71-28.58 49.31-46.81 70.45-34.78 41.03-78.69 73.78-127.95 95.33-44.31 19.91-93.2 31.12-144.53 31.12H512.56c-36.03 0-71.24-4.97-104.38-13.68-97.32-26.54-179.74-88.72-229.42-171.22-12-19.89-21.95-41.01-30.23-62.97-13.65-37.32-21.14-77.93-21.14-119.8v-360.2c0-9.11.43-18.25 1.23-27.34.85-13.28 2.93-26.57 5.83-39.35 8.28-40.68 24.44-78.36 46.36-112.36 33.98-52.64 99.82-78.75 163.61-67.57 33.96 5.81 69.99 10.39 100.62 15.79 18.63 3.29 35.21-14.11 28.58-31.12-4.12-11.18-4.54-30.69-3.72-48.06.82-18.26 15.73-32.75 33.96-32.75h2706.42c81.56 0 157.35 27.76 217.81 74.6 27.34 20.75 51.37 45.18 71.21 72.95 25.26 34.39 44.73 73.78 56.34 115.65 8.7 30.66 13.25 62.97 13.25 96.13z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2342.63.06c-147.83 7.85-295.29 19.88-442.73 34.79-594.28 60.91-1184 171.22-1771.28 280.62.85-13.28 2.93-26.57 5.83-39.35C635.56 169.18 1137.49 67.58 1645.24.06h697.4z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3182.64 438.57c130.86 1.26 260.62 13.69 389.81 38.14v73.78c-157.23-30.26-315.55-42.71-475.27-38.56-19.63.43-34.47-41.87-17.37-61.74 67.53-79.15 140.4-114 215.78-126.86-118.55-4.98-236.8-6.19-355.63-3.3-245.48 7.03-545.88 122.27-779.04-23.21-18.76-11.63-24.65-46.85-5.86-64.68 185.78-179.47 437.14-131.39 648.44-137.6 224.47-6.65 449.22-13.25 673.68-19.88 18.49 20.75 34.75 45.18 48.18 72.95-204.27 5.38-408.83 10.75-612.86 16.59-210.43 5.34-490.39-51.86-687.95 91.61 135.63 60.92 278.27 23.61 418.38 8.67 125.82-13.25 251.94-21.95 378.32-24.45 180.74-3.73 361.77 3.72 542.24 23.23 5.89 30.66 8.97 62.97 8.97 96.13v26.13c-135.63-11.6-272.1-30.29-389.81 53.04z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3427.59 1039.56c-29.98 19.91-63.07 31.12-97.8 31.12h-48.21c-2.54-.82-5.06-1.68-7.57-2.5-271.27-89.93-526.83-179.89-807.06-165.82-258.1 13.29-506.37 97.44-758.58 168.32h-204.01c-24.38 0-48.21-4.97-70.63-13.68 112.66-2.11 224.75-39.39 334.31-73.39 239.34-73.78 480.04-133.05 724.7-146.73 258.64-14.9 494.05 56.77 743.72 145.91 49.89 17.83 99.48 35.65 149.93 47.67 6.43 1.64 21.3 4.99 41.2 9.1z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3572.46 704.68v6.62c0 18.22-.83 36.49-2.81 54.32-39.79-7.08-79.3-13.28-119.1-17.83-56.89-6.22-150.47-35.63-204.84-10.38-49.05-24.46-65-4.15-48.21 60.96 27.2 6.62 54.65 13.25 81.83 19.87 63.89 15.32 127.8 30.26 191.4 45.63 10.93 2.47 39.79 4.95 75.11 9.92-8.67 25.71-19.34 49.31-31.67 70.45-.56 0-1.12-.4-1.41-.4-72.59-18.66-144.89-38.97-217.43-58.05-36.99-9.93-260.64-52.62-161.42-184.02 45.67-60.1 161.69-22.77 214.09-20.31 75.38 4.15 149.91 11.61 224.46 23.22z",
    style: {
      fill: "url(#g)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBg);
export default __webpack_public_path__ + "static/media/button_bg.d65db6ac015d1c47903fd42a6631b3a9.svg";
export { ForwardRef as ReactComponent };